import { DIVIDER_CSS_VARIABLES } from "@busbud/design-system-components/dist/Divider";

import { makeTssStyles } from "../tss/tss";

export const useStyles = makeTssStyles<void, "label">({
  name: "SelectableCard",
  uniqId: "7owOrT"
})((theme, _params, classes) => {
  const { colors, spacing, styles } = theme.busbud;
  return {
    card: {
      cursor: "pointer",
      "&:hover": {
        boxShadow: styles.shadow.subtle.md
      }
    },
    checked: {
      "&:hover": {
        boxShadow: "unset"
      }
    },
    disabled: {
      opacity: styles.opacity[500],
      cursor: "not-allowed",
      [`& .${classes.label} *`]: {
        cursor: "not-allowed"
      }
    },
    divider: {
      [DIVIDER_CSS_VARIABLES.color]: colors.border.secondary.transparent,
      margin: spacing(0, 2.5)
    },
    header: {
      padding: spacing(2, 2.5, 2, 2),
      minHeight: "unset"
    },
    header_left_content: {
      paddingRight: spacing(2)
    },
    label: {
      pointerEvents: "none"
    },
    content: {
      padding: spacing(2, 2.5),
      "&:not(:first-of-type):last-child": {
        paddingBottom: spacing(2.5)
      }
    }
  };
});
